<template>
  <section class="grid-card-section">
    <header v-if="temHeader" class="grid-card-section__header">
      <span v-if="label" class="grid-card-section__label">{{ label }}</span>
      <small v-if="hint" class="grid-card-section__hint">{{ hint }}</small>
      <div v-if="$slots.acoes" class="grid-card-section__acoes">
        <slot name="acoes" />
      </div>
    </header>
    <div class="grid-card-section__corpo">
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * Seção interna de um GridCard, agrupando campos sob um label.
 *
 * Exemplo:
 *  <GridCardSection label="Custo" hint="valores em reais">
 *    <GridCardField label="CMV" :valor="12.50" tipo="monetary" />
 *  </GridCardSection>
 */
export default {
  name: "GridCardSection",
  props: {
    label: { type: String, default: null },
    hint: { type: String, default: null },
  },
  computed: {
    temHeader() {
      return !!(this.label || this.hint || this.$slots.acoes);
    },
  },
};
</script>

<style scoped>
.grid-card-section {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f4f7;
}

.grid-card-section:last-child {
  border-bottom: none;
}

.grid-card-section__header {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.grid-card-section__label {
  font-size: 11px;
  font-weight: 700;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.grid-card-section__hint {
  font-size: 11px;
  color: #98a2b3;
  font-weight: 400;
}

.grid-card-section__acoes {
  margin-left: auto;
  display: flex;
  gap: 6px;
}

.grid-card-section__corpo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
